/*
 * patient-intake (schema)
 */
import { boolean, json, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"

export type PharmaEntry = { name: string; prescriptionNames?: string | null }

export const patientIntakes = schema.table("patient_intakes", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),

	// --- Versioning ---
	isLatest: boolean("is_latest").notNull().default(true),

	// --- Personal background ---
	kNumber: text("k_number"),
	guardian: text("guardian"),
	emergencyContactName: text("emergency_contact_name"),
	emergencyContactRelationship: text("emergency_contact_relationship"),
	emergencyContactPhone: text("emergency_contact_phone"),
	occupation: text("occupation"),
	employer: text("employer"),
	familyDoctor: text("family_doctor"),
	referringProfessional: text("referring_professional"),
	hearAboutUs: text("hear_about_us"),
	referredTo: text("referred_to"),
	marketingEmailsOptIn: boolean("marketing_emails_opt_in"),

	// --- Veteran / military ---
	veteranStatus: json("veteran_status").$type<string[]>(),
	medicalReleaseYear: text("medical_release_year"),
	voluntaryReleaseYear: text("voluntary_release_year"),

	// --- Personal ---
	maritalStatus: text("marital_status"),
	hasChildren: boolean("has_children"),
	childrenDetails: text("children_details"),

	// --- Cannabis ---
	hasCannabisRx: boolean("has_cannabis_rx"),
	cannabisRxFirstYear: text("cannabis_rx_first_year"),
	cannabisRxDailyAllotment: text("cannabis_rx_daily_allotment"),

	// --- Conventional treatments & therapies ---
	conventionalTreatments: json("conventional_treatments").$type<string[]>(),
	therapies: json("therapies").$type<string[]>(),

	// --- Medications ---
	currentMedications: text("current_medications"),

	// --- Pharmaceuticals ---
	psychiatricPharmaceuticals: json("psychiatric_pharmaceuticals").$type<PharmaEntry[]>(),
	painPharmaceuticals: json("pain_pharmaceuticals").$type<PharmaEntry[]>(),

	// --- Current professionals ---
	seeingPsychotherapist: boolean("seeing_psychotherapist"),
	psychotherapistFrequency: text("psychotherapist_frequency"),
	seeingPsychiatrist: boolean("seeing_psychiatrist"),
	psychiatristFrequency: text("psychiatrist_frequency"),

	// --- Other ---
	allergies: text("allergies"),
	additionalDetails: text("additional_details"),

	// --- Consent ---
	consentSigned: boolean("consent_signed"),
	cancellationPolicySigned: boolean("cancellation_policy_signed"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
